<div>
    <div class="container text-center mt-4 mb-2">
        <img src="./assets/images/logo-ust.svg" alt="logo" class="img-fluid" style="height: 120px; cursor: pointer"
            (click)="returnToLogin()" />
    </div>
</div>

<div style="background-color:#114B43; height:900px">
    <div class="container pt-4 pb-4">
        <fieldset style="background: #eee !important;">

            <form [formGroup]="ContactForm" novalidate>
                <div class="container" style="background: #9cb93f;">
                    <br>
                    <h2 class="titlex">Creación de una cuenta de usuario</h2>
                    <h5 *ngIf="showForm" class="titlex mb-2">Ingresa tus datos para crear una cuenta y acceder a
                        Matrícula Online
                    </h5>
                </div>

                <div class="alert alert-primary mt-3 ml-3 mr-3" role="alert" *ngIf="buscando">
                    <h4 class="alert-heading">Validando postulación Admisión centralizada.</h4>
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                    </div>
                    <p>Esperar la validación, para continuar con el registro.</p>
                </div>

                <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert" *ngIf="buscandoError">
                    <label class="alert-heading">Estimado Postulante:</label>
                    <p>De acuerdo con nuestros registros, no estás seleccionado en ninguna de nuestras carreras
                        adscritas al Proceso de Admisión Centralizada DEMRE. <br><br> Te invitamos a ver nuestra oferta
                        académica de carreras para la Admisión Directa
                        en <a href="https://www.tupuedes.cl/">https://www.tupuedes.cl/</a>, donde también podrás
                        encontrar toda la información relacionada con cada proceso de postulación a la Universidad Santo
                        Tomás. </p>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
                            style="background-color: #114B43!important; border-color:#114B43;"
                            (click)="returnToLogin()">
                            Ir al inicio
                        </button>
                    </div>
                </div>

                <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert" *ngIf="Yaexiste">
                    <label class="alert-heading">Estimado Postulante:</label>
                    <p>Ya existe un acceso para su correo. Favor intente con otro correo o contactese con Santo Tomás.
                    </p>
                </div>

                <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert" *ngIf="mensajes?.showEnListaEspera">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <p>
                        Futuro Tomasino! Para realizar tu matrícula en la Universidad Santo Tomás, contacta a nuestros
                        asesores, quienes podrán ayudarte. Encuentra los contactos en
                        <a href="https://www.tupuedes.cl/sistemas-de-admision/matricula-asistida/"
                            class="text-primary">https://www.tupuedes.cl/sistemas-de-admision/matricula-asistida/</a>
                    </p>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
                            style="background-color: #114B43!important; border-color:#114B43;"
                            (click)="returnToLogin()">
                            Ir al inicio
                        </button>
                    </div>
                </div>

                <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert" *ngIf="mensajes?.showTokenExpirado">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <label class="alert-heading">Estimado Postulante:</label>
                    <p>El token proporcionado ya no es válido, favor solicitar nuevamente.</p>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
                            style="background-color: #114B43!important; border-color:#114B43;"
                            (click)="returnToLogin()">
                            Ir al inicio
                        </button>
                    </div>
                </div>

                <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert" *ngIf="mensajes?.showSeleccionado">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <p>
                        Futuro Tomasino! Para realizar tu matrícula en la Universidad Santo Tomás, contacta a nuestros
                        asesores, quienes podrán ayudarte. Encuentra los contactos en
                        <a href="https://www.tupuedes.cl/sistemas-de-admision/matricula-asistida/"
                            class="text-primary">https://www.tupuedes.cl/sistemas-de-admision/matricula-asistida/</a>
                    </p>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
                            style="background-color: #114B43!important; border-color:#114B43;"
                            (click)="returnToLogin()">
                            Ir al inicio
                        </button>
                    </div>
                </div>

                <div *ngIf="showForm" class="form">
                    <label class="ml-3">Los campos con (*) son obligatorios</label>
                    <div class="row mt-2 container">
                        <h4 class="font-weight-bold ml-3" style="color: black;">Datos personales</h4>
                    </div>
                    <div class="row mt-2 container">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <label>Tipo de documento</label>
                                    <div class="d-flex justify-content-start">
                                        <input id="true" type="radio" value='1' name="Nacionalidad"
                                            formControlName="Nacionalidad" disabled readonly>
                                        <label class="custom-control-label" for="true">RUT</label>
                                        <input id="false" type="radio" value='2' name="Nacionalidad"
                                            formControlName="Nacionalidad" disabled readonly>
                                        <label class="custom-control-label" for="false">Pasaporte</label>
                                    </div>
                                </div>
                                <div class="col-sm-6" *ngIf="ContactForm.get('Nacionalidad').value === '1'">
                                    <label>Rut <span class="text-danger">*</span></label>
                                    <input type="text" formatRut class="form-control form-control-sm"
                                        formControlName="RUT" disabled readonly>
                                    <span class="text-muted"
                                        *ngIf="(!ContactForm.controls.RUT.valid && ContactForm.controls.RUT?.touched)">Por
                                        favor, ingrese un RUT válido</span>
                                </div>
                                <div class="col-sm-6" *ngIf="ContactForm.get('Nacionalidad').value === '2'">
                                    <label>Pasaporte <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="Passaporte">
                                    <span class="text-muted"
                                        *ngIf="(!ContactForm.controls.Passaporte.valid && ContactForm.controls.Passaporte?.touched)">Por
                                        favor, ingrese un Passaporte válido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <label style="color: brown; display: none"> {{this.ContactForm.value | json}}</label>
                    <div class="row mt-2 container">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Primer Nombre</label>
                                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                                        placeholder="Ingresa primer nombre" formControlName="Nombre">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['Nombre'].valid && ContactForm.controls['Nombre']?.touched">Por
                                        favor, ingrese un nombre válido</span>
                                </div>
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Segundo Nombre</label>
                                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                                        placeholder="Ingresa segundo nombre" formControlName="Nombre2">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['Nombre2'].valid && ContactForm.controls['Nombre2']?.touched">Por
                                        favor, ingrese un segundo nombre válido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2 container">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-sm-6">

                                    <label class="font-weight-bold">Apellido Paterno</label>
                                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                                        placeholder="Ingresa tu apellido paterno" formControlName="ApellidoP">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['ApellidoP'].valid && ContactForm.controls['ApellidoP']?.touched">Por
                                        favor, ingrese un apellido válido</span>
                                </div>
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Apellido Materno</label>
                                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                                        placeholder="Ingresa tu apellido materno" formControlName="ApellidoM">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['ApellidoM'].valid && ContactForm.controls['ApellidoM']?.touched">Por
                                        favor, ingrese un apellido válido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2 container">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Teléfono móvil</label>

                                    <input type="text" appOnlyNumbersInput pattern="9[0-9 ]*"
                                        class="form-control form-control-sm"
                                        placeholder="Ingresar teléfono móvil ejem: 9xxxxxxxx"
                                        formControlName="Telefono" />
                                    <!-- digitOnly-->
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['Telefono'].valid && ContactForm.controls['Telefono']?.touched">Por
                                        favor, ingrese un telefono válido</span>
                                </div>
                                <div class="col-sm-6">

                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-2 container">
                        <h4 class="font-weight-bold ml-3" style="color: black;">Datos de acceso</h4>
                    </div>
                    <div class="row mt-2 container">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Correo electrónico</label>
                                    <input type="text" class="form-control form-control-sm"
                                        placeholder="Ingresa tu e-mail" formControlName="Correo"
                                        (change)="ChangeCorreo($event)">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['Correo'].valid && ContactForm.controls['Correo']?.touched">Por
                                        favor, ingrese un correo electrónico válido</span>
                                    <label>(En minúsculas y
                                        recomendamos que uses tu correo personal)</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Confirmacion Correo electrónico <span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control form-control-sm"
                                        placeholder="Confirma tu e-mail" formControlName="Correo2">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['Correo2'].valid && ContactForm.controls['Correo2']?.touched">Por
                                        favor, ingrese la confirmacion del correo electrónico válido</span>
                                    <label>(En minúsculas y
                                        recomendamos que uses tu correo personal)</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2 container" *ngIf="ContactForm.get('Nacionalidad').value === '1'">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Clave <span class="text-danger">*</span></label>
                                    <input type="password" class="form-control form-control-sm"
                                        placeholder="Clave Personal / Ejemplo: Abcd.1234" formControlName="Clave">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['Clave'].valid && ContactForm.controls['Clave']?.touched">
                                        La contraseña debe cumplir con este formato:<br>
                                        &nbsp;&nbsp;&nbsp;* letras mayúsculas y minúsculas. <br>
                                        &nbsp;&nbsp;&nbsp;* Incluir caracteres especiales. <br>
                                        &nbsp;&nbsp;&nbsp;* números. <br>
                                        &nbsp;&nbsp;&nbsp;* El largo de la clave debe ser de 8 a 16 caracteres.<br>
                                        &nbsp;&nbsp;&nbsp;* Ejemplo: Abcd.1234</span><br>
                                </div>
                                <div class="col-sm-6">
                                    <label class="font-weight-bold">Confirmacion Clave <span
                                            class="text-danger">*</span></label>
                                    <input type="password" class="form-control form-control-sm"
                                        placeholder="Confirmar Clave" formControlName="Clave2">
                                    <span class="text-muted"
                                        *ngIf="!ContactForm.controls['Clave2'].valid && ContactForm.controls['Clave2']?.touched">las
                                        claves no son iguales</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row container mt-2" *ngIf="ContactForm.get('Nacionalidad').value === '1'">
                        <div class="col-md-12">
                            <re-captcha (resolved)="resolved($event)" siteKey="6LcvntYZAAAAAD7vJSrZr18NQr-anQiVSDFWRRWd"
                                formControlName="Captcha">
                            </re-captcha>
                            <span class="text-muted"
                                *ngIf="!ContactForm.controls['Captcha'].valid && ContactForm.controls['Captcha']?.touched">Debe
                                verificar el captcha</span>
                        </div>
                    </div>

                    <div class="row container mt-2">
                        <div class="col-md-12">

                            <div class="progress" id="progress" *ngIf="progress">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                                    role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                                    style="width: 100%"></div>
                            </div>
                            <div class="alert alert-success alert-dismissible fade show mt-2 lg-success" role="alert"
                                *ngIf="MensajeSucces">
                                <strong>Registrado!</strong> En breve será redireccionado.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="alert alert-success alert-dismissible fade show mt-2 lg-success" role="alert"
                                *ngIf="MensajeNoAceptaTerminos">
                                <strong>Advertencia!</strong> No se le puede otorgar acceso al sistema si no acepta los
                                terminos.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert"
                                *ngIf="MensajeError">
                                <strong>Advertencia!</strong> Ha fallado el proceso de registro.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert"
                                *ngIf="MensajeErrorBloqueoFinanciero">
                                <p class="text-left">Estimado(a) estudiante,</p>
                                <p class="text-left">
                                    Nuestros sistemas indican que existe una situación financiera que es necesaria
                                    aclarar y, eventualmente pagar o pactar, para poder realizar una nueva matrícula. Te
                                    agradeceríamos tomar contacto con el área financiera de la sede en la que estudiaste
                                    anteriormente
                                    para profundizar la situación.
                                </p>
                                <p class="text-left">
                                    Si necesitas información de contacto de nuestras Sedes, podrás obtenerla en
                                    <a href="http://www.santotomas.cl/contactossedes.html"
                                        class="text-primary">http://www.santotomas.cl/contactossedes.html</a>
                                </p>
                                <p class="text-left">
                                    Atentamente, <br /> Dirección de Admisión, Santo Tomás.
                                </p>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row container mt-2" *ngIf="ContactForm.get('Nacionalidad').value === '1'">
                        <div class="col-md-12">
                            <app-apibutton text="Ingresa tus datos para continuar registro" [progress]="progress"
                                (click)="OpenModal()">
                            </app-apibutton>
                        </div>
                    </div>
                    <div class="row text-center container mt-2 mb-4"
                        *ngIf="ContactForm.get('Nacionalidad').value === '1'">
                        <div class="col-md-12">
                            <a class="text-white mt-1 btn btn-primary btn-block" href="/login"
                                style="cursor:pointer; background-color: #000000;">Volver</a>

                        </div>
                    </div>
                </div>
            </form>
        </fieldset>
    </div>
</div>

<app-terminos-ycondiciones-modal (onSendFormContact)="SendFormContact($event)"></app-terminos-ycondiciones-modal>